import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { listHours } from '@mkcore/portal/schema';
import { Card, EmptyState, Skeleton } from '@mkcore/ui';
import { call } from '@/lib/api';

/** The engagements whose hours the client may see (CO-1352). */
export const Route = createFileRoute('/portal/_client/hours/')({
  component: Hours,
});

function Hours() {
  const { t } = useTranslation();
  const q = useQuery({ queryKey: ['portal', 'hours'], queryFn: () => call(listHours, {}) });
  if (!q.data) return <Skeleton className="h-32" />;
  return (
    <>
      <h1 className="text-2xl font-bold">{t('portal.modules.hours')}</h1>
      {!q.data.items.length ? (
        <EmptyState title={t('portal.hours.empty')} />
      ) : (
        <ul className="grid gap-2">
          {q.data.items.map((e) => (
            <li key={e.id}>
              <Card className="p-4">
                <Link to="/portal/hours/$id" params={{ id: e.id }} className="font-bold hover:underline">
                  {e.name}
                </Link>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
